var _path, _g, _rect, _rect2, _rect3, _rect4, _rect5, _path2, _path3, _rect6, _path4, _g2, _path5, _path6, _path7, _circle, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 179.333C144.183 179.333 180 143.516 180 99.3333C180 55.1505 144.183 19.3333 100 19.3333C55.8172 19.3333 20 55.1505 20 99.3333C20 143.516 55.8172 179.333 100 179.333Z",
    fill: "url(#paint0_linear_2750_71280)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2750_71280)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.3334,
    y: 42.3709,
    width: 83.0247,
    height: 103.353,
    rx: 10.6667,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66.6667,
    y: 55.7043,
    width: 33.3333,
    height: 6.53333,
    rx: 3.26667,
    fill: "#101828"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 66.6667,
    y: 74.2376,
    width: 66.6667,
    height: 6.53333,
    rx: 3.26667,
    fill: "#D0D5DD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 66.6667,
    y: 92.7709,
    width: 66.6667,
    height: 6.53333,
    rx: 3.26667,
    fill: "#D0D5DD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 66.6667,
    y: 111.304,
    width: 66.6667,
    height: 6.53333,
    rx: 3.26667,
    fill: "#D0D5DD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 66.6667,
    y: 129.838,
    width: 66.6667,
    height: 6.53333,
    rx: 3.26667,
    fill: "#D0D5DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.046 31.4493H192.1C193.666 31.4493 194.979 32.7934 194.979 34.5059V54.3186C194.979 56.0311 193.666 57.3752 192.1 57.3752H152.046C150.48 57.3752 149.167 56.0311 149.167 54.3186V34.5059C149.167 32.7934 150.48 31.4493 152.046 31.4493Z",
    fill: "white",
    stroke: "#F2F4F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.667 48.6667C160.876 48.6667 162.667 46.8758 162.667 44.6667C162.667 42.4575 160.876 40.6667 158.667 40.6667C156.458 40.6667 154.667 42.4575 154.667 44.6667C154.667 46.8758 156.458 48.6667 158.667 48.6667Z",
    fill: "#1570EF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 40.6667,
    width: 21.3333,
    height: 8,
    rx: 4,
    fill: "#D0D5DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.406 150.376C131.993 150.376 139.973 147.778 146.604 143.326L173.736 169.227L183.576 157.81L157.394 132.817C162.23 126.012 165.073 117.693 165.073 108.709C165.073 85.697 146.418 67.0422 123.406 67.0422C100.395 67.0422 81.7397 85.697 81.7397 108.709C81.7397 131.721 100.395 150.376 123.406 150.376ZM158.946 108.709C158.946 128.191 143.152 143.984 123.67 143.984C104.188 143.984 88.3948 128.191 88.3948 108.709C88.3948 89.2268 104.188 73.4334 123.67 73.4334C143.152 73.4334 158.946 89.2268 158.946 108.709Z",
    fill: "#53B1FD"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_2750_71280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.667 144.667C143.733 144.667 160 128.549 160 108.667C160 88.7844 143.733 72.6667 123.667 72.6667C103.6 72.6667 87.3334 88.7844 87.3334 108.667C87.3334 128.549 103.6 144.667 123.667 144.667Z",
    fill: "white",
    fillOpacity: 0.3
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.949 108.667L138.741 99.9081C139.565 99.0416 140.016 97.89 139.999 96.6981C139.983 95.5061 139.499 94.3677 138.65 93.5247C137.802 92.6818 136.657 92.2008 135.458 92.1839C134.258 92.167 133.1 92.6156 132.228 93.4343L123.416 102.193L114.623 93.4343C114.2 92.9893 113.691 92.6331 113.127 92.3868C112.563 92.1405 111.955 92.0091 111.339 92.0005C110.723 91.9918 110.112 92.106 109.541 92.3363C108.97 92.5666 108.452 92.9083 108.016 93.3413C107.581 93.7743 107.237 94.2896 107.005 94.857C106.773 95.4243 106.658 96.0321 106.667 96.6443C106.676 97.2566 106.808 97.8609 107.056 98.4214C107.304 98.982 107.662 99.4875 108.11 99.9081L116.917 108.667L108.11 117.425C107.662 117.846 107.304 118.351 107.056 118.912C106.808 119.472 106.676 120.077 106.667 120.689C106.658 121.301 106.773 121.909 107.005 122.476C107.237 123.044 107.581 123.559 108.016 123.992C108.452 124.425 108.97 124.767 109.541 124.997C110.112 125.227 110.723 125.342 111.339 125.333C111.955 125.324 112.563 125.193 113.127 124.947C113.691 124.7 114.2 124.344 114.623 123.899L123.435 115.14L132.248 123.899C133.128 124.669 134.27 125.077 135.442 125.04C136.614 125.002 137.728 124.521 138.556 123.696C139.384 122.87 139.864 121.762 139.899 120.597C139.933 119.432 139.519 118.298 138.741 117.425L129.949 108.667Z",
    fill: "#1570EF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M173.734 169.228L183.575 157.812L185.057 159.226C186.495 160.599 187.356 162.517 187.45 164.558C187.545 166.598 186.865 168.595 185.561 170.109C184.256 171.622 182.434 172.528 180.495 172.627C178.556 172.727 176.658 172.012 175.22 170.639L173.738 169.224L173.734 169.228Z",
    fill: "#53B1FD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5429 60.7811C37.5304 59.8304 37.4111 58.8715 37.1726 57.9061C36.3361 54.5181 32.6042 52.3429 28.6322 51.8315C24.6618 51.3201 20.5328 52.4839 18.9415 55.431C18.0313 57.116 17.9057 58.5683 18.2777 59.7927C18.648 61.0106 19.5268 62.0203 20.7195 62.807C24.045 64.9985 29.8689 65.446 32.5258 64.5298C33.7546 64.1052 34.9551 63.5939 36.1242 63.0087C35.4557 66.8393 32.9651 70.4683 29.6413 73.7383C22.4176 80.8455 11.2078 86.2398 5.103 88.2232C4.77501 88.3297 4.59295 88.6936 4.69496 89.0362C4.79696 89.3787 5.14535 89.5705 5.47334 89.464C11.6989 87.4413 23.1269 81.9323 30.4934 74.6841C34.2991 70.9404 37.0109 66.7262 37.4739 62.2957C46.077 57.4947 53.1422 48.7844 59.1826 41.4543C59.407 41.1839 59.3772 40.7724 59.1167 40.538C58.8562 40.3053 58.4638 40.3348 58.2394 40.6069C52.4454 47.637 45.7208 55.9998 37.5429 60.7811ZM36.2922 61.4777C36.3393 60.409 36.2388 59.3239 35.9673 58.229C35.2438 55.2966 31.9184 53.5625 28.48 53.1199C26.3723 52.8494 24.2051 53.0724 22.5055 53.8657C21.4368 54.364 20.5563 55.0868 20.0259 56.0703C19.3291 57.3603 19.1784 58.4634 19.464 59.3994C19.7497 60.3418 20.4591 61.0991 21.3834 61.7072C24.4138 63.7053 29.7166 64.1298 32.135 63.2955C33.5615 62.8038 34.9457 62.1908 36.2922 61.4777Z",
    fill: "#101828"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 122.667,
    r: 4,
    fill: "#F04438"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.923 150.263C39.6369 149.995 40.3881 149.639 40.9674 149.124C41.6554 148.512 41.9352 147.724 42.1231 146.895C42.3643 145.829 42.4607 144.694 42.7532 143.627C42.8615 143.231 43.0699 143.081 43.1594 143.014C43.3854 142.846 43.6139 142.802 43.8289 142.818C44.0836 142.838 44.4336 142.939 44.6638 143.389C44.6966 143.453 44.7392 143.551 44.768 143.685C44.7889 143.784 44.8024 144.092 44.8246 144.219C44.88 144.531 44.9263 144.844 44.9698 145.158C45.1146 146.204 45.1979 147.093 45.6554 148.054C46.2761 149.359 46.898 150.157 47.7415 150.51C48.5571 150.852 49.5323 150.788 50.7782 150.52C50.8968 150.49 51.0141 150.464 51.1302 150.443C51.6795 150.342 52.2047 150.721 52.3126 151.297C52.4205 151.873 52.0714 152.434 51.5269 152.56C51.4133 152.586 51.3013 152.611 51.1905 152.634C49.5068 153.073 47.5577 154.639 46.425 156.009C46.0759 156.432 45.5647 157.614 45.0432 158.368C44.6584 158.924 44.226 159.29 43.8629 159.42C43.6197 159.507 43.4145 159.494 43.2451 159.45C42.9989 159.386 42.7946 159.245 42.6379 159.022C42.5526 158.9 42.4734 158.736 42.4357 158.527C42.4176 158.427 42.4156 158.171 42.416 158.055C42.3097 157.671 42.1797 157.295 42.0849 156.907C41.8588 155.981 41.4153 155.395 40.8886 154.62C40.3959 153.895 39.8666 153.44 39.0908 153.076C38.9899 153.05 38.1756 152.84 37.888 152.72C37.4679 152.543 37.2677 152.247 37.195 152.088C37.0716 151.818 37.0588 151.582 37.0835 151.385C37.12 151.094 37.2439 150.846 37.4638 150.645C37.6 150.52 37.8035 150.399 38.0759 150.34C38.2863 150.293 38.8447 150.267 38.923 150.263ZM43.7005 148.753C43.7382 148.842 43.7784 148.931 43.8211 149.021C44.7302 150.931 45.7468 151.998 46.9825 152.516L47.024 152.533C46.1973 153.179 45.449 153.901 44.8771 154.593C44.6416 154.878 44.3298 155.47 43.993 156.077C43.6869 155.03 43.1864 154.29 42.5571 153.364C42.0763 152.657 41.5725 152.125 40.9534 151.691C41.4338 151.432 41.8921 151.128 42.2912 150.773C42.9559 150.182 43.3952 149.497 43.7005 148.753Z",
    fill: "#F04438"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2750_71280",
    x: 39.3334,
    y: 35.7042,
    width: 123.025,
    height: 143.353,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.3333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.570833 0 0 0 0 0.570833 0 0 0 0 0.570833 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2750_71280"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2750_71280",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_2750_71280",
    x: 82,
    y: 67.3334,
    width: 83.3333,
    height: 82.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2750_71280"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2750_71280",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2750_71280",
    x1: 100,
    y1: 19.3333,
    x2: 100,
    y2: 320.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrations);
export default __webpack_public_path__ + "static/media/Illustrations.9c7f6ce3eb1eac9f4f7596f0789e4e4a.svg";
export { ForwardRef as ReactComponent };